import { render, staticRenderFns } from "./ResetPassword.vue?vue&type=template&id=76e7a63f&scoped=true&"
import script from "./ResetPassword.vue?vue&type=script&lang=js&"
export * from "./ResetPassword.vue?vue&type=script&lang=js&"
import style0 from "./ResetPassword.vue?vue&type=style&index=0&id=76e7a63f&prod&lang=css&"
import style1 from "./ResetPassword.vue?vue&type=style&index=1&id=76e7a63f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e7a63f",
  null
  
)

export default component.exports